export { watchListar } from './listar';
export { watchListarAtivos } from './listarAtivos';
export { watchBuscarPorId } from './buscarPorId';
export { watchSalvar } from './salvar';
export { watchDeletar } from './deletar';
export { watchDeletarRegistro } from './deletarRegistro';



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/redux/sagas.js